// extracted by mini-css-extract-plugin
module.exports = {"settings":"SettingsPage_settings__1eEAe"};